module.exports = __webpack_public_path__ + "img/icon-calendario.outline.ba557719.svg";